module.exports = __webpack_public_path__ + "static/media/mfd.ff8517a9.pdf";